<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import HeaderSection from './components/sections/HeaderSection.vue'
import HeroSection from './components/sections/HeroSection.vue'
import FeaturesSection from './components/sections/FeaturesSection.vue'
import UseCasesSection from './components/sections/UseCasesSection.vue'
import StatsSection from './components/sections/StatsSection.vue'
import HowItWorksSection from './components/sections/HowItWorksSection.vue'
import TestimonialsSection from './components/sections/TestimonialsSection.vue'
import CtaSection from './components/sections/CtaSection.vue'
import NewsletterSection from './components/sections/NewsletterSection.vue'
import FooterSection from './components/sections/FooterSection.vue'

const showBackToTop = ref(false)

const handleScroll = () => {
  showBackToTop.value = window.scrollY > 500
}

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)

  // Initialize intersection observer for animations
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate--visible')
        }
      })
    },
    { threshold: 0.1 }
  )

  document.querySelectorAll('.animate').forEach((el) => {
    observer.observe(el)
  })
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<template>
  <HeaderSection />

  <main>
    <HeroSection />
    <FeaturesSection />
    <UseCasesSection />
    <StatsSection />
    <HowItWorksSection />
    <TestimonialsSection />
    <CtaSection />
    <NewsletterSection />
  </main>

  <FooterSection />

  <!-- Back to Top Button -->
  <button
    :class="['back-to-top', { 'back-to-top--visible': showBackToTop }]"
    @click="scrollToTop"
    aria-label="Back to top"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M18 15l-6-6-6 6"/>
    </svg>
  </button>
</template>
